<template>
  <div class="field-icon position-relative">
    <!-- Label del campo (si showLabel es true) -->
    <small
      v-if="showLabel && field.label"
      :for="computedFieldId"
      class="form-label w-100"
    >
      <strong>
        {{ $t(field.label) }}
      </strong>
      <FieldHistoryLabelButton :field="field" :mode="mode" />
    </small>
    <br v-if="showLabel && field.label" />

    <!-- MODO FILTRO -->
    <FilterFieldIcon
      v-if="mode === 'edit' && isFilter"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :filterOperator="filterOperator"
      :defaultIcons="defaultIcons"
      @input="$emit('input', $event)"
      @filter-operator-change="$emit('filter-operator-change', $event)"
    />

    <!-- MODO EDIT -->
    <EditFieldIcon
      v-else-if="effectiveFieldMode === 'edit'"
      :field="field"
      :value="value"
      :fieldId="computedFieldId"
      :editingFields="editingFields"
      :defaultIcons="defaultIcons"
      :disableLock="disableLock"
      :calculated="calculated"
      @input="$emit('input', $event)"
      @update:editingFields="$emit('update:editingFields', $event)"
    />

    <!-- MODO VIEW -->
    <ViewFieldIcon
      v-else-if="effectiveFieldMode === 'view'"
      :field="field"
      :value="value"
      :item="item"
      :modelName="modelName"
      :isGroupModel="isGroupModel"
    />
  </div>
</template>

<script>
import EditFieldIcon from "./icon/editField.vue";
import ViewFieldIcon from "./icon/viewField.vue";
import FilterFieldIcon from "./icon/filterField.vue";
import fieldEditableByMixin from "@/mixins/fieldEditableByMixin";
import FieldHistoryLabelButton from "../common/FieldHistoryLabelButton.vue";

export default {
  name: "FieldIcon",
  mixins: [fieldEditableByMixin],
  components: {
    FieldHistoryLabelButton,
    EditFieldIcon,
    ViewFieldIcon,
    FilterFieldIcon,
  },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Array],
      default: null,
    },
    mode: {
      type: String,
      required: true,
      validator: (value) => ["edit", "view"].includes(value),
    },
    fieldId: {
      type: String,
      default: null,
    },
    editingFields: {
      type: String,
      default: "",
    },
    item: {
      type: Object,
      default: null,
    },
    modelName: {
      type: String,
      default: "",
    },
    isGroupModel: {
      type: Boolean,
      default: false,
    },
    defaultIcons: {
      type: Array,
      default: () => [],
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    disableLock: {
      type: Boolean,
      default: false,
    },
    calculated: {
      type: Boolean,
      default: false,
    },
    isFilter: {
      type: Boolean,
      default: false,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    computedFieldId() {
      return this.fieldId || `field-icon-${this.field.key}`;
    },
  },
};
</script>

<style scoped>
.field-icon {
  width: 100%;
}
</style>
